module.exports = __webpack_public_path__ + "static/media/slumber.a99fabbf.svg";